import { Loading } from "@/components/fallbacks";

/**
 * AuthLoader component
 *
 * Displays a loading spinner with an optional loader text.
 * Used during authentication processes like sign-in and sign-out.
 */
export const AuthLoader = ({ loaderText = "Loading..." }: { loaderText?: string }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div className="flex items-center justify-center flex-col gap-6 bg-base-200 p-6 border border-base-content/10 rounded-2xl w-[327px] drop-shadow-2xl">
        <Loading />
        <h3>{loaderText}</h3>
      </div>
    </div>
  );
};
